export const facilitySelectKey = {
  country: 'country',
  facilityType: 'facilityType',
  facilityName: 'facilityName',
  isLeased: 'isLeased',
  year: 'year'
};
export const facilitySelectLabel = {
  country: 'Country',
  facilityType: 'Facility Type',
  facilityName: 'Facility Name',
  isLeased: 'isLeased',
  year: 'year'
};
